import { Container } from "@mui/material";
import { NavLink } from "react-router-dom";

import { appRoutes } from "routes";

import { Content, Label, Root, StyledButton, Tagline } from "./styles";

const Hero = () => {
  return (
    <Root>
      <Container>
        <Content>
          <Label variant="homeHeroSecondary" component="h3">
            Ecards for
          </Label>
          <Tagline variant="homeHeroMain" component="h3">
            A Birthday
            <br />
            Celebration
          </Tagline>
          <StyledButton id="home-browse-birthdays" component={NavLink} to={appRoutes.categoryPath("birthday-ecards")}>
            BROWSE BIRTHDAYS
          </StyledButton>
        </Content>
      </Container>
    </Root>
  );
};

export default Hero;
